
class AutoInfracaoSiatuDetalhe {
    constructor(
        {
            id = null,
            auto_infracao_transito_id = null,
            data_extincao_lancamento = null,
            motivo_extincao_lancamento = null,
            data_estorno_lancamento = null,
            data_cancelamento_lancamento = null,
            data_inscricao_divida_ativa = null,
            valor_inscrito_divida_ativa = null,
            data_prescricao_lancamento = null,
            motivo_prescricao_lancamento = null,
            valor_prescrito = null,
            data_inicio_suspensao_siatu = null,
            data_fim_suspensao_siatu = null,
            origem_suspensao = null,
            siatu_fechamento_suspensao_id = null,
        } = {}
    ) {
        this.id = id;
        this.auto_infracao_transito_id = auto_infracao_transito_id;
        this.data_extincao_lancamento = data_extincao_lancamento;
        this.motivo_extincao_lancamento = motivo_extincao_lancamento;
        this.data_estorno_lancamento = data_estorno_lancamento;
        this.data_cancelamento_lancamento = data_cancelamento_lancamento;
        this.data_inscricao_divida_ativa = data_inscricao_divida_ativa;
        this.valor_inscrito_divida_ativa = valor_inscrito_divida_ativa;
        this.data_prescricao_lancamento = data_prescricao_lancamento;
        this.motivo_prescricao_lancamento = motivo_prescricao_lancamento;
        this.valor_prescrito = valor_prescrito;
        this.data_inicio_suspensao_siatu = data_inicio_suspensao_siatu;
        this.data_fim_suspensao_siatu = data_fim_suspensao_siatu;
        this.origem_suspensao = origem_suspensao;
        this.siatu_fechamento_suspensao_id = siatu_fechamento_suspensao_id;
    }

}

export default AutoInfracaoSiatuDetalhe;